import { Heading } from '@philo/web-shared';
import React from 'react';
import { NOOP } from '../../utils/defaults';
import { TextLink, TextLinkType } from '../../web-shared/design-system/text-link/text-link';
import Dialog from '../../web-shared/general/dialog';
import { PHILO_HELP_URL } from '../../web-shared/utils/constants';
import { Anchor } from '../anchor';
import LoaderOverlay from '../overlay/loader-overlay';
import styles from './suspense-loader.module.sass';

enum LabelId {
  TITLE = 'suspense-boundary-title',
  DESCRIPTION = 'suspense-boundary-description',
}

const Links = {
  CONTACT: 'philo.com/contact',
  BROWSERS: `${PHILO_HELP_URL}/using-philo/browsers`,
};

export default function SuspenseLoader({ error }: { error?: string }) {
  return (
    <LoaderOverlay message={error} key="loader-overlay">
      {error && (
        <Dialog
          alert
          ariaDescribedBy={LabelId.DESCRIPTION}
          ariaLabelledBy={LabelId.TITLE}
          className={styles.suspenseErrorDialog}
          onDismiss={NOOP}
        >
          <Heading level={1} className="visually-hidden">
            Philo
          </Heading>
          <Heading level={2} id={LabelId.TITLE} className={styles.suspenseErrorDialogTitle}>
            Something went wrong.
          </Heading>
          <div className={styles.suspenseErrorDialogError} id={LabelId.DESCRIPTION}>
            Please{' '}
            <TextLink as={Anchor} type={TextLinkType.INLINE} href={window.location.href}>
              reload the page
            </TextLink>{' '}
            or try using the latest version of a{' '}
            <TextLink as={Anchor} type={TextLinkType.INLINE} target="_blank" href={Links.BROWSERS}>
              modern browser
            </TextLink>
            .{'\n '}
            <TextLink as={Anchor} type={TextLinkType.INLINE} target="_blank" href={Links.CONTACT}>
              Contact Philo support
            </TextLink>{' '}
            for more help.
          </div>
        </Dialog>
      )}
    </LoaderOverlay>
  );
}
